// POST /api/v1/talent_surveys/chat_survey_results
// Sends the get-results endpoint response as the payload (as is).
import {generateFetchOptions} from '../../index';

export async function createFromChatSession(getResultsPayload: Record<string, unknown>): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/talent_surveys/chat_survey_results`,
    generateFetchOptions({
      method: 'POST',
      isProtected: false,
      body: getResultsPayload,
    })
  );
}
